import { FloatTransferInitPayload, FloatTransferInitResponse, RequestFloatTransferResponse } from './../../../interfaces/floatTransfer';
import { RequestFloatTransferService } from './../../../service/request-float-transfer/request-float-transfer.service';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import swal from 'sweetalert';
import { RequestFloatTransferTellersInterface, RequestFloatTransferTellersListInterface } from '../../../interfaces/requestTransfer';
import { PriceFormatterPipe } from '../../../pipes/price-formatter.pipe';
import { NgxMaskDirective } from 'ngx-mask';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-request-float-transfer',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    PriceFormatterPipe,
    NgxMaskDirective,
    TranslatePipe
  ],
  templateUrl: './request-float-transfer.component.html',
  styleUrl: './request-float-transfer.component.scss'
})
export class RequestFloatTransferComponent implements OnInit {
  selectedStep: number = 1;
  isButtonLoading: boolean = false;
  heading: string = this.translate.instant('CUSTOMER.FLOAT_TRANSFER_REQUEST');
  agentAccount: string = '';
  amount: string = '';
  requestResponse!: RequestFloatTransferResponse;
  tellerList!: RequestFloatTransferTellersInterface;

  constructor(
    private dialogRef: MatDialogRef<RequestFloatTransferComponent>,
    private requestService: RequestFloatTransferService,
    private translate: TranslateService
  ){}

  ngOnInit() {
  }

  onConfirm(){
    // this.dialogRef.close(true);
    this.getTellers();
  }
  onCancel(){
    this.dialogRef.close(false);
  }

  getTellers(){
    if (this.agentAccount && this.amount) {
      this.heading = this.translate.instant('CUSTOMER.FLOAT_UV_REQUEST');
      this.isButtonLoading = true;
      this.requestService.getTellerList(this.agentAccount, this.amount).subscribe({
        next: (res:any)=>{
          if (res.success) {
            this.tellerList = res;
            this.selectedStep += 1;
          }else{
            swal(this.translate.instant('ALERT.WARNING'), res?.message ,'warning')
          }
          this.isButtonLoading = false;
        },
        error: (err)=>{
          swal(this.translate.instant('ALERT.ERROR'), err, "error");
          this.isButtonLoading = false;
        }
      })
    }else{
      swal(this.translate.instant('ALERT.WARNING'), this.translate.instant('ALERT.INVALID_FORM_VALUES'), 'warning')
    }
  }

  requestPayment(teller:RequestFloatTransferTellersListInterface){
    this.isButtonLoading = true;
    let body: any = {
      senderRefId: localStorage.getItem('senderId') as string,
      approvalAccountNo: teller.agentAccountNo.toString(),
      approvalTellerAccess: teller.tellerAccess.toString(),
      amount: {
        currency: 'XAF',
        value: this.amount.toString(),
      },
      remarks: "",
      particulars: ""
    };

    this.requestService.requestFloat(body).subscribe({
      next:(res:RequestFloatTransferResponse)=>{
        if(res.success){
          this.requestResponse = res;
          this.selectedStep += 1;
        }else{
          swal(this.translate.instant('ALERT.WARNING'), res.description, "warning");
        }
        this.isButtonLoading = false;
      },
      error:(err)=>{
        console.error(err);
        swal(this.translate.instant('ALERT.ERROR'), err, "error");
        this.isButtonLoading = false;
      }
    })
  }

  closeDialog(){
    this.dialogRef.close();
  }
}
